import { Injectable } from '@angular/core';
import { URLSearchParams } from '@angular/http';

import { Api } from './api.service';
import { SubscriptionOffer } from '../entities/subscription-offer.entity';

@Injectable()
export class SubscriptionOfferService {
  offers: Promise<SubscriptionOffer[]>;
  dataStore: SubscriptionOffer[] = [];

  constructor(protected http: Api) {}

  getAll(forceReload: boolean = false): Promise<SubscriptionOffer[]> {
    if (!this.offers || forceReload) {
      const params = new URLSearchParams();
      params.set('limit', '1000');

      this.offers = this.http.get('subscriptionoffer', { search: params }).toPromise().then(res => {
        return this.dataStore = res.items;
      });
    }

    return this.offers;
  }
}



// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/services/subscription-offer.service.ts